import { SVGProps, useId } from 'react';

export const Lite = (props: SVGProps<SVGSVGElement>) => {
    const liteId = useId();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 28 28"
            {...props}
        >
            <g clipPath={`url(#lite_a_${liteId})`}>
                <mask
                    id={`lite_b_${liteId}`}
                    width="29"
                    height="29"
                    x="-1.111"
                    y="-.111"
                    fill="#000"
                    maskUnits="userSpaceOnUse"
                >
                    <path fill="#fff" d="M-1.111-.111h29v29h-29z" />
                    <path
                        fillRule="evenodd"
                        d="M14.585 2.889c-5.614 0-10.527 4.514-10.527 10.526 0 2.48.866 4.76 2.304 6.561L2.89 23.462l1.649 1.649 3.473-3.474a10.54 10.54 0 0 0 6.574 2.304c2.69 0 5.391-1.029 7.438-3.087a10.467 10.467 0 0 0 3.088-7.439V2.889H14.585Zm.081 3.777v9.5h5.112v3.5h-8.611v-13h3.5Z"
                        clipRule="evenodd"
                    />
                </mask>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    d="M14.585 2.889c-5.614 0-10.527 4.514-10.527 10.526 0 2.48.866 4.76 2.304 6.561L2.89 23.462l1.649 1.649 3.473-3.474a10.54 10.54 0 0 0 6.574 2.304c2.69 0 5.391-1.029 7.438-3.087a10.467 10.467 0 0 0 3.088-7.439V2.889H14.585Zm.081 3.777v9.5h5.112v3.5h-8.611v-13h3.5Z"
                    clipRule="evenodd"
                />
                <path
                    fill="#97FF95"
                    fillRule="evenodd"
                    d="M14.585 2.889c-5.614 0-10.527 4.514-10.527 10.526 0 2.48.866 4.76 2.304 6.561L2.89 23.462l1.649 1.649 3.473-3.474a10.54 10.54 0 0 0 6.574 2.304c2.69 0 5.391-1.029 7.438-3.087a10.467 10.467 0 0 0 3.088-7.439V2.889H14.585Zm.081 3.777v9.5h5.112v3.5h-8.611v-13h3.5Z"
                    clipRule="evenodd"
                />
                <path
                    fill="#414141"
                    d="m6.362 19.976 1.771 1.765 1.576-1.58-1.393-1.745-1.954 1.56ZM2.89 23.462l-1.771-1.765-1.762 1.768 1.765 1.765 1.768-1.768Zm1.649 1.649L2.77 26.879l1.768 1.767 1.768-1.767-1.768-1.768Zm3.473-3.474 1.555-1.958-1.746-1.385-1.576 1.575 1.767 1.768Zm14.012-.783-1.762-1.773-.006.005-.005.005 1.773 1.763Zm3.088-17.965h2.5v-2.5h-2.5v2.5ZM14.666 16.166h-2.5v2.5h2.5v-2.5Zm0-9.5h2.5v-2.5h-2.5v2.5Zm5.112 9.5h2.5v-2.5h-2.5v2.5Zm0 3.5v2.5h2.5v-2.5h-2.5Zm-8.611 0h-2.5v2.5h2.5v-2.5Zm0-13v-2.5h-2.5v2.5h2.5Zm-4.609 6.749c0-4.57 3.731-8.026 8.027-8.026v-5C7.652.389 1.558 5.96 1.558 13.415h5Zm1.758 5.001a7.983 7.983 0 0 1-1.758-5.001h-5c0 3.072 1.075 5.898 2.851 8.122l3.907-3.12Zm-3.657 6.81 3.474-3.485-3.541-3.53-3.474 3.486 3.541 3.53Zm1.647-1.883-1.65-1.649-3.535 3.536 1.649 1.649 3.536-3.536Zm-.062-3.474L2.77 23.343l3.536 3.536 3.473-3.474-3.535-3.536Zm8.34 1.572a8.04 8.04 0 0 1-5.018-1.762l-3.109 3.917a13.04 13.04 0 0 0 8.128 2.845v-5Zm5.666-2.35a7.967 7.967 0 0 1-5.665 2.35v5c3.324 0 6.674-1.273 9.211-3.825l-3.546-3.525Zm2.36-5.676c0 2.055-.784 4.11-2.35 5.666l3.526 3.545a12.967 12.967 0 0 0 3.825-9.211h-5Zm0-10.526v10.526h5V2.889h-5Zm-8.025 2.5H25.11v-5H14.585v5Zm2.581 10.777v-9.5h-5v9.5h5Zm2.612-2.5h-5.111v5h5.11v-5Zm2.5 6v-3.5h-5v3.5h5Zm-11.111 2.5h8.61v-5h-8.61v5Zm-2.5-15.5v13h5v-13h-5Zm6-2.5h-3.5v5h3.5v-5Z"
                    mask={`url(#lite_b_${liteId})`}
                />
            </g>
            <defs>
                <clipPath id={`lite_a_${liteId}`}>
                    <path fill="#fff" d="M.667.667h26.667v26.667H.667z" />
                </clipPath>
            </defs>
        </svg>
    );
};
